<h3 mat-dialog-title>{{ data.title }}</h3>
<mat-dialog-content>
  @if (( periods$ | async )?.length > 1) {
    <div class="flex-1"Fill class="flex-col gap-4">
      <p>
        @if ((currentPeriod$ | async); as period) {
          @if (period.period_type === 'FREEFORM') {
            {{ 'migrate_period_sections_dialog.description.freeform' | translate: { periodName: period.name || undefined, isCopying: data.isCopying } }}
          }
          @if (period.period_type === 'DATE') {
            {{ 'migrate_period_sections_dialog.description.date' | translate: { periodStartDate: (period.start_date | i18n_date: 'fullDate' | async | titlecase) || undefined, isCopying: data.isCopying } }}
          }
        }
        @if (!(currentPeriod$ | async)) {
          {{ 'migrate_period_sections_dialog.current_field' | translate: { isCopying: data.isCopying } }}
        }
      </p>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="periodControl" [placeholder]="'migrate_period_sections_dialog.period.select.placeholder' | translate">
          @for (period of ( periods$ | async ); track period) {
            <mat-option [value]="period.id">
              @if (period.period_type === 'FREEFORM') {
                {{ period?.name ? period.name : ('generic.field' | translate) }}
              }
              @if (period.period_type === 'DATE') {
                {{ period?.start_date
                ? (period.start_date | i18n_date: 'fullDate' | async | titlecase)
                : ('generic.field' | translate) }}
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @if (( periods$ | async )?.length === 1) {
    <p>
      {{ 'migrate_period_sections_dialog.single_period_option' | translate: {
      currentPeriodName: (currentPeriod$ | async)?.name || undefined,
      periodName: (periods$ | async)[0]?.name || undefined,
      isCopying: data.isCopying
      } }}
    </p>
  }
  @if (data.isCopying) {
    <p>
      {{ 'migrate_period_sections_dialog.copy_to_another_program' | translate }}
      <a class="pointer-anchor" (click)="copyToOtherProgram();">{{ 'generic.here' | translate }}</a>
    </p>
  }
</mat-dialog-content>
<mat-dialog-actions class="flex-row justify-between flex-1"Fill>
  <button mat-button (click)="cancel()">
    {{ data.cancelText }}
  </button>
  <button mat-button color="primary" (click)="close()" [disabled]="!periodControl.valid">
    {{ data.confirmText }}
  </button>
</mat-dialog-actions>
